(function () {
  var IN_VIEW_CLASS = 'marine-research--in-view';
  var sections = document.querySelectorAll('.marine-research');
  if (!sections.length) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) {
    sections.forEach(function (el) { el.classList.add(IN_VIEW_CLASS); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add(IN_VIEW_CLASS);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

  sections.forEach(function (el) { observer.observe(el); });
})();
